<!-- Contenuti modale -->
<ng-template #windowContents>
    <div
        class="window"
        #window
        [@window]
        [class.fullScreen]="windowSize === 0"
        [class.small]="windowSize === 2"
        [class.seMessageBox]="windowSize === 3"
        [style.width.px]="fixedWidthPx"
        [style.z-index]="_zIndex + 1"
        (click)="onWindowClick($event)"
    >
        <div class="window-container">
           
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>

<!-- Overlay nascosto tramite "hidden" -->
<ng-container *ngIf="alwaysPresent; else standardTemplate">
    <div [hidden]="!visible" class="overlay" [style.z-index]="zIndex">
        <ng-container *ngTemplateOutlet="windowContents"></ng-container>
    </div>
</ng-container>

<!-- Overlay nascosto tramite "ngIf" -->
<ng-template #standardTemplate>
    <div *ngIf="visible" class="overlay" [style.z-index]="zIndex">
        <ng-container *ngTemplateOutlet="windowContents"></ng-container>
    </div>
</ng-template>
